import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import Helmet from 'react-helmet';
import moment from 'moment';

import fetchMg from '../utilities/fetchManager';
import EventMg from '../utilities/EventManager';
import { Table } from '../components/CommonTable';
import { DragSourceAndDropTarget } from '../components/DnDWrapper';
import masterSlideLoader from '../utilities/masterSlideLoader';
import dialogLoader from '../utilities/dialogLoader';
import * as api from '../services/FieldTree';
import * as dialog from '../components/FieldTreeDialog';
import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';
import FieldTreePartnerBoxEvents, {
  FIELD_TREE_PARTNER_BOX,
} from '../components/FieldTreePartnerBoxEvents';
import {
  APPROVAL_STATUS_FIELDTREE,
  CALL_FROM_PAGE,
  HEADER_CONSTANTS,
  PARTNER_COMPABY_BRANCH_FLAG,
  USER_BOX_STATUS,
  USER_ROLES,
  USER_ROLES_IDS,
  USER_STATUS,
  DATE_TIME_FORMAT,
} from '../utilities/constants';
import {
  csvDownloader,
  isApiFlagOn,
  getOneMasterTypeNameCompanyNumber,
} from '../utilities/commonUtil';
import DropdownSelector from '../../src/components/dropdowns/DropdownSelector';
import { Modal } from '../components/Modal';
import { DialogSuccessError } from '../components/modals/DialogSuccessError';
import { messageUtility } from '../utilities/messageUtility';
import PrimeContractorButton from '../components/button/PrimeContractorButton';
import ForemanNewPasswordDialog, {
  DialogType,
} from '../components/dialogs/ForemanNewPasswordDialog';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import FieldTreeService from '../services/FieldTrees';
import FieldTreeUserService from '../services/FieldTreeUsers';
import {
  isLoginUserPrimaryCompany,
  isPrimaryCompanyRoleId,
  isTargetRoleId,
} from '../utilities/roleUtility';
import Confirmation from '../components/modals/common/Confirmation';
import { ConfirmDialog } from '../components/modals/ConfirmDialog';
import Tippy from '../components/ReactTippy';
import { TouchDeviceInvisible } from '../components/TouchDeviceInvisible';
import { MasterPageHeader } from '../components/PageHeader';
import UsersApi from '../services/users/UsersApi';
import {
  HEAD_OFFICE_OPTION,
  PartnerCompanyBranchDropdown,
} from '../components/PartnerCompanyBranchDropdown';
import { BuildeeManagerIcon } from '../components/icons/BuildeeManagerIcon';
import { Information } from '../components/modals/common';
import { Description } from '../components/Description';

const workZonelabels = [
  { zone: 'day', ref: 'work_hour_zone_day_flag' },
  { zone: 'night', ref: 'work_hour_zone_night_flag' },
  { zone: 'midnight', ref: 'work_hour_zone_midnight_flag' },
];

// ダイアログ名
const DIALOG_NAME = {
  close: 'close', // クローズ
};

/**
 * @description 施工体系図 現場監督一覧 ページ
 */
export default class FieldTreePartnerBox extends React.Component {
  constructor(props) {
    super(props);
    const params = {
      offset: 0,
      limit: 30,
      refresh: 0, //テーブルリフレッシュ用のカウンター
      //role_code : 0,
    };
    this.state = {
      params, // 絞り込み処理で更新するので stateで保持
      tempParams: _.cloneDeep(params), // 検索条件(保存用)
      role_id: LocalStorageService.getRoleId(),
      constructor_flag: isLoginUserPrimaryCompany(),
      company: {
        // undefinedが表示される対策
        company_name: '',
        company_branch_name: '',
      }, //会社情報
      companyAddress: '',
      oneMasterTypeNameCompanyNumber: '',
      company_id: '',
      data: [], //一覧データ
      copy_data: [], //一覧データのコピー
      master: {}, //マスター情報
      search_form_open: true, // search_form の開閉
      edit_user_id: null, //編集するユーザーのid
      field_data: {}, //現場情報
      field_id: SessionStorageService.getFieldId(), //現場ID
      field_tree_id: this.props.view.state.id, //選択した会社のid
      field_tree: {}, //会社情報
      partner_company_branch_id: '',
      canSort: false, //ドラッグアンドドロップしない
      paramReset: 0, //絞り込みリセット
      permissions: {},
      work_history_exists: {
        day: false,
        night: false,
        midnight: false,
      },
      // 何次請か
      nestNo: 1,
      // 自分の直下かどうか
      isSubordinate: false,
      showDragItem: true,
      visibleDialogName: null, // 開閉用ダイアログ名
      apiMessage: null, // APIレスポンスメッセージ
      isLoading: true, // ロード中フラグ
      isFetch: false, // 再読み込みフラグ
      isNewSearch: false, // 検索ボタン押下時のフラグ(BLDE_V2-41384)
      showSendConfirmDialog: false, // 管理者招待の送信確認ダイアログ
      showInformationModal: false,
      showRequestRegisterDialog: false,
      confirmDialogFormValue: {
        partner_company_branch_id: '',
        name_sei: '',
        name_mei: '',
        kana_sei: '',
        kana_mei: '',
        email: '',
      },
      displayWorkHourZone: {
        work_hour_zone_day_flag: 0,
        work_hour_zone_night_flag: 0,
        work_hour_zone_midnight_flag: 0,
      }, // 作業時間帯チェックボックス表示判定用
      isManagerPermission: false,
      partnerCompanyBranchName: '',
      partnerCompanyBranchBlockFlag: false,
      partnerCompanyBranchIdSearched: undefined,
      informationMessage: '',
      isShowWarningAddUser: false,
    };

    this.slideRef = null; //スライド全体Ref
    this.searchRef = null; //検索フォームRef
    this.searchButtonRef = React.createRef(); // 検索ボタン要素
    this.document = null; //全体
    this.searchForm = null; //検索フォーム
    this.Users = null; //協力会社ユーザー名

    this.total = 0; // 検索結果件数を保持
    this.multiselectform = [];
    this.updatingFlag = false; // 多重更新防止Flag
    this.userId = LocalStorageService.getUserId();
    this.companyId = SessionStorageService.getCompanyId();
    this.clearFlag = false;

    //リフレッシュ
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.REFRESH_LIST, () => {
      _.each(document.querySelectorAll('.search-form__body input'), input => {
        input.value = null;
        input.checked = null;
      });
      let _params = _.clone(this.state.params);
      _params.refresh = _params.refresh + 1;
      this.setState({ params: _params, isFetch: true });
    });

    // search formを開閉させる。
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.SEARCH_FORM_OPEN, () => {
      this.setState({ search_form_open: !this.state.search_form_open });
    });

    // 検索条件をクリア
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.SEARCH_CLEAR, () => {
      _.each(
        this.document.querySelectorAll('.search-form__body input'),
        input => {
          input.checked = null;
        }
      );
      if (this.Users) {
        this.Users.resetValue();
      }
      this.setState({
        data: [],
        params: { offset: 0, limit: 30 },
        tempParams: { offset: 0, limit: 30 },
        paramReset: this.state.paramReset + 1,
        user_id: undefined,
        user_name: undefined,
        showDragItem: true,
        isLoading: true,
        isFetch: true,
        isNewSearch: true,
        partnerCompanyBranchIdSearched: undefined,
      });
      this.clearFlag = true;
    });

    //新規登録フォーム
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.NEW_FORM, key => {
      //パラメータをjson>urlencode でidに渡す
      const param = {
        id: 0,
        prev_id: this.state.field_tree_id,
        field_id: this.state.field_id,
        field_tree_id: this.state.field_tree_id,
        company_id: this.state.company.company_id,
        company_branch_id: this.state.company.company_branch_id,
        partner_company_branch_id: this.state.partner_company_branch_id,
        form_type: key, //worker or default
      };
      const json = encodeURIComponent(JSON.stringify(param));

      //slideLoader.show(
      masterSlideLoader.show('PartnerUserForm', { state: { id: json } }, '1');
    });

    //編集フォーム
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.EDIT_FORM, data => {
      const param = {
        id: data.id,
        prev_id: this.state.field_tree_id,
        field_id: this.state.field_id,
        field_tree_id: this.state.field_tree_id,
        company_id: this.state.company.company_id,
        company_branch_id: this.state.company.company_branch_id,
        user_id: data.user_id,
      };
      const json = encodeURIComponent(JSON.stringify(param));

      masterSlideLoader.show(
        'PartnerUserForm',
        { state: { id: json } },
        this.props.vw
      );
    });

    // ドラッグアンドドロップ
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.DRAG_ITEM, () => {
      this.setState({ canSort: true });
    });

    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.ORDER_UPDATE, data => {
      this.setState({ copy_data: data });
    });

    // 並び順を保存
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.SAVE_ORDER, save_flag => {
      if (save_flag === true) {
        this.saveOrder();
      }
      this.setState({ canSort: false });
    });

    //検索して追加
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.SEARCH_AND_ADD, () => {
      dialogLoader.show(dialog.WorkerManager, {
        state: {
          field_id: this.state.field_id,
          field_tree_id: this.state.field_tree_id,
          company: this.state.company,
          company_id: this.state.company_id,
          isManagerPermission: this.state.isManagerPermission,
          addPartnerBoxDetailPermission: this.state.permissions
            .partner_box_detail.add,
        },
        callback: {
          back: () => {
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.REFRESH_LIST);
            dialogLoader.close();
          },
          submit: () => {
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.REFRESH_LIST);
            dialogLoader.close();
          },
          addUser: () => {
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.NEW_PRE_DIALOG);
          },
          requestRegister: () => {
            this.setState({ showRequestRegisterDialog: true });
          },
          close: () => {
            dialogLoader.close();
          },
        },
      });
    });

    //CSVを出力
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.EXPORT_CSV, () => {
      dialogLoader.show(dialog.CSVExportPartnerForeman, {
        state: {
          fieldId: this.state.field_id,
          fieldTreeId: this.state.field_tree_id,
        },
        callback: {
          csvDownloadPreparation: () => {
            // 不要なパラムを削除
            let params = _.clone(this.state.params);
            delete params.offset;
            delete params.limit;
            delete params.refresh;

            // 協力会社本社・支店判定
            if (params.partner_company_branch_id === HEAD_OFFICE_OPTION.id) {
              delete params.partner_company_branch_id;
              params.partner_company_branch_flag =
                PARTNER_COMPABY_BRANCH_FLAG.HEAD_OFFICE;
            } else {
              params.partner_company_branch_id = this.state.params.partner_company_branch_id;
              params.partner_company_branch_flag =
                PARTNER_COMPABY_BRANCH_FLAG.BRANCH;
            }

            const apiPath = `api/private/fields/${
              this.state.field_id
            }/field_trees/${
              this.state.field_tree_id
            }/field_tree_users/list.csv`;

            csvDownloader(apiPath, params);
          },
          close: () => {
            dialogLoader.close();
          },
        },
      });
    });

    //新規作成誤登録防止ダイアログ
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.NEW_PRE_DIALOG, () => {
      dialogLoader.show(dialog.PartnerUserNewPreDialog, {
        callback: {
          new: () => {
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.NEW_DIALOG);
          },
          back: () => {
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.SEARCH_AND_ADD);
          },
        },
        state: {
          companyName: this.state.company.company_name,
          companyAddress: this.state.companyAddress,
          oneMasterTypeNameCompanyNumber: this.state
            .oneMasterTypeNameCompanyNumber,
        },
      });
    });

    //新規作成ダイアログ
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.NEW_DIALOG, () => {
      dialogLoader.show(dialog.PartnerUserNewDialog, {
        callback: {
          invite: () => {
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.INVITE_USER_DIALOG);
          },
          // 職長新規登録のボタン
          new: () => {
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.NEW_FORM, 'default');
          },
          back: () => {
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.SEARCH_AND_ADD);
          },
        },
        state: {
          companyName: this.state.company.company_name,
        },
      });
    });

    //管理者招待
    /*
    https://v2-dev.buildee.jp/apidocs/public/field_tree_users/create.html
    /api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users
      {
      "user": {
        "company_id": 1,
        "company_branch_id": 1,
        "role_code": 5,
        "fullname": "テスト 番頭",
        "email": "test@hoge.hoge"
      }
    }
    */
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.INVITE_USER_DIALOG, () => {
      dialogLoader.show(dialog.PartnerUserInviteMail, {
        state: {
          fieldId: this.state.field_id,
          fieldTreeId: this.state.field_tree_id,
          companyId: this.state.company.company_id,
          companyBranchId: this.state.company.company_branch_id,
          companyName: this.state.company.company_name,
          companyAddress: this.state.companyAddress,
          oneMasterTypeNameCompanyNumber: this.state
            .oneMasterTypeNameCompanyNumber,
          isManagerPermission: this.state.isManagerPermission,
          partner_company_branch_id: this.state.partner_company_branch_id,
          partnerCompanyBranchName: this.state.partnerCompanyBranchName,
          partnerCompanyBranchBlockFlag: this.state
            .partnerCompanyBranchBlockFlag,
          readOnly: this.state.showSendConfirmDialog,
        },
        callback: {
          back: () => {
            this.setState({
              confirmDialogFormValue: {
                partner_company_branch_id: '',
                name_sei: '',
                name_mei: '',
                kana_sei: '',
                kana_mei: '',
                email: '',
              },
            });
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.SEARCH_AND_ADD);
          },
          submit: this.submitInviteMail,
          submitIntegrateUser: this.submitInviteMailIntegrate,
          submitSuccess: () => {
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.REFRESH_LIST);
          },
          cancel: this.closeConfirmationDialog,
          confirm: this.submitInviteMail,
        },
      });
    });

    //ユーザの削除
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.DELETE_USER, data => {
      this.deleteUser(data);
    });

    //ユーザ情報の更新
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.UPDATE_FORM, data => {
      this.updateUser(data);
    });
  }

  submitInviteMail = async (...args) => {
    if (!this.state.showSendConfirmDialog) {
      const throughFlag = args[1] && args[1].throughFlag;
      return this.setState(
        {
          showSendConfirmDialog: true,
          confirmDialogFormValue: {
            partner_company_branch_id: args[0].partner_company_branch_id,
            name_sei: args[0].name_sei,
            name_mei: args[0].name_mei,
            kana_sei: args[0].kana_sei,
            kana_mei: args[0].kana_mei,
            email: args[0].email,
          },
        },
        () => {
          if (throughFlag) {
            this.submitInviteMail(args[0]);
          } else {
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.INVITE_USER_DIALOG);
          }
        }
      );
    }
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const {
      confirmDialogFormValue,
      company,
      field_id,
      field_tree_id,
    } = this.state;
    const user = {
      company_id: company.company_id,
      company_branch_id: company.company_branch_id,
      role_code: 5,
      name_sei: confirmDialogFormValue.name_sei,
      name_mei: confirmDialogFormValue.name_mei,
      kana_sei: confirmDialogFormValue.kana_sei,
      kana_mei: confirmDialogFormValue.kana_mei,
      email: confirmDialogFormValue.email,
    };
    const { partner_company_branch_id: branchId } =
      confirmDialogFormValue || {};
    if (branchId && branchId !== HEAD_OFFICE_OPTION.id) {
      user.partner_company_branch_id = branchId;
    }

    const { result, message } = await api.PartnerUserInvite(
      field_id,
      field_tree_id,
      { user }
    );
    this.setState({
      showSendConfirmDialog: false,
      confirmDialogFormValue: {
        name_sei: '',
        name_mei: '',
        kana_sei: '',
        kana_mei: '',
        email: '',
      },
    });
    if (result) {
      // 成功
      dialogLoader.close();
      this.loadMaster();
      dialogLoader.show(dialog.InviteSuccess, {
        callback: {
          done: () => {
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.REFRESH_LIST);
            dialogLoader.close();
          },
        },
      });
    } else {
      // 失敗
      dialogLoader.close();
      dialogLoader.show(dialog.MailError, {
        message,
        callback: {
          done: () => {
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.INVITE_USER_DIALOG);
          },
        },
      });
    }
    this.updatingFlag = false;
  };

  submitInviteMailIntegrate = async values => {
    const { company, field_id, field_tree_id } = this.state;
    const user = {
      company_id: company.company_id,
      company_branch_id: company.company_branch_id,
      role_code: USER_ROLES.partner.id,
      name_sei: values.name_sei,
      name_mei: values.name_mei,
      kana_sei: values.kana_sei,
      kana_mei: values.kana_mei,
      email: values.email,
    };
    const branchId = values.partner_company_branch_id;
    if (branchId && branchId !== HEAD_OFFICE_OPTION.id) {
      user.partner_company_branch_id = branchId;
    }
    const { result } = await FieldTreeService.createIntegrate(
      field_id,
      field_tree_id,
      { user }
    );
    if (result) {
      this.loadMaster();
    }
    return result;
  };

  componentDidMount() {
    this.document = ReactDOM.findDOMNode(this.slideRef);
    this.searchForm = ReactDOM.findDOMNode(this.searchRef);
    this.addEventListener();
    this.FieldData();
    this.searchFormInit();
    this.loadMaster();
    this.settingPermission();
  }

  getMasterTable() {
    this.loadMaster();
  }

  /**
   * イベントのバインド処理
   * <背景>
   * コンストラクタで定義されていたが、画面遷移して戻った場合にイベントが発火しない不具合があった。
   * そのためcomponentDidMountで発火させるよう対応した。
   */
  addEventListener() {
    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_FIELD, data => {
      this.setState({ field_data: data.entities.field });
      if (isTargetRoleId(USER_ROLES_IDS.PRIME_COMPANY)) {
        this.setState({
          displayWorkHourZone: {
            work_hour_zone_day_flag:
              data.entities.field.work_hour_zone_day_flag,
            work_hour_zone_night_flag:
              data.entities.field.work_hour_zone_night_flag,
            work_hour_zone_midnight_flag:
              data.entities.field.work_hour_zone_midnight_flag,
          },
        });
      }
    });
  }

  settingPermission = () => {
    UsersApi.fetchCompanyUserPermissions(this.companyId, {
      buildee_manager_flg: 1,
    }).then(res => {
      let isManagerPermission = false;
      if (res.result === true) {
        if (res.data.total > 0) {
          const companyUserPermissions =
            res.data.entities.company_user_permissions;
          for (let permission of companyUserPermissions) {
            if (permission.user_id === Number(this.userId)) {
              isManagerPermission = true;
              break;
            }
          }
        }

        this.setState({
          isManagerPermission,
        });
      }
    });
  };

  loadMaster = async () => {
    await this.getCompany();
    await this.getField();
  };

  componentWillUnmount() {
    EventMg.deleteEvent(FIELD_TREE_EVENTS.TREE_FIELD);
    FieldTreePartnerBoxEvents.removeAll();
  }

  //現場
  FieldData = async () => {
    const field = await api.FieldData(this.state.field_id);
    if (field) {
      EventMg.trigger(FIELD_TREE_EVENTS.TREE_FIELD, field);
    }
  };

  /**
   * 会社情報
   *
   * @returns
   * @memberof FieldTreePartnerBox
   */
  getCompany = async () => {
    const response = await api.FieldTree(
      this.state.field_tree_id,
      this.state.field_id,
      {
        require_permissions: 1,
      }
    );

    if (response === null) {
      return;
    }

    const entities = response.entities;
    // 何次請か(1開始)
    const nestNo = response.login_user_tree_nest_no;

    // 自分の直下かどうか
    const isSubordinate = response.is_subordinate;

    let promise = new Promise(resolve => {
      if (entities) {
        const company = entities.field_tree;

        this.setState({
          company_id: entities.field_tree.company_id,
          nestNo,
          isSubordinate,
          company,
          companyAddress: _.get(entities.field_tree, 'company.address') || '',
          oneMasterTypeNameCompanyNumber: getOneMasterTypeNameCompanyNumber(
            _.get(entities.field_tree, 'company.one_master_flag'),
            _.get(entities.field_tree, 'company.company_number')
          ),
          work_history_exists: entities.work_history_exists,
          approval_flags: {
            possible_approval: entities.possible_approval,
            possible_approval_request: entities.possible_approval_request,
          },
          possible_approvals: entities.possible_approval,
          possible_approval_requests: entities.possible_approval_request,
          permissions: entities.field_tree.permissions,
          partner_company_branch_id:
            entities.field_tree.partner_company_branch_id,
          partnerCompanyBranchName:
            _.get(entities.field_tree, 'partner_company_branch_name') ||
            HEAD_OFFICE_OPTION.name,
          partnerCompanyBranchBlockFlag: !!_.get(
            company,
            'partner_company_branch_block_flag'
          ),
        });
        if (isTargetRoleId(USER_ROLES_IDS.PARTNER_COMPANY)) {
          this.setState({
            displayWorkHourZone: {
              work_hour_zone_day_flag: company.work_hour_zone_day_flag,
              work_hour_zone_night_flag: company.work_hour_zone_night_flag,
              work_hour_zone_midnight_flag:
                company.work_hour_zone_midnight_flag,
            },
          });
        }
        resolve(true);
      }
    });

    return promise;
  };

  //現場情報
  getField = async () => {
    const data = await api.FieldData(this.state.field_id);
    let promise = new Promise(resolve => {
      if (data.result) {
        let _field = data.data.entities.field;
        this.setState({ field: _.cloneDeep(_field) });
        resolve(true);
      } else {
        resolve(false);
      }
    });
    return promise;
  };

  /**
   * ユーザ情報更新
   */
  updateUser = param => {
    const _param = {
      position_id: param.position_id,
      approval_level: param.approval_level,
      block_flag: param.block_flag,
    };
    const data = fetchMg
      .PatchAjax(
        `/api/private/fields/${this.state.field_id}/field_contractor_users/${
          param.id
        }`,
        _param
      )
      .catch(() => ({ result: false }));
    if (data.result) {
      console.log('Updated Success');
    }
  };

  /**
   * ユーザ削除
   */
  deleteUser = param => {
    const data = fetchMg
      .DeleteAjax(
        `/api/private/fields/${this.state.field_id}/field_contractor_users/${
          param.id
        }`,
        {}
      )
      .catch(() => ({ result: false }));
    if (data.result) {
      console.log('deleteUser Success');
    }
  };

  /**
   *
   * https://v2-dev.buildee.jp/apidocs/public/field_tree_users/update_list.html
   * /api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users/list
   */
  saveOrder = () => {
    let _param = {};
    // 一度もソートが実行されなかった場合,copy_dataのlengthが空になる為、this.state.dataを使う
    const targetData =
      this.state.copy_data.length === 0
        ? this.state.data
        : this.state.copy_data;
    _param.field_tree_users = _.map(targetData, (val, index) => {
      return {
        id: val.id,
        order_number: index + 1,
      };
    });

    const data = FieldTreeUserService.updateOrder(
      this.state.field_id,
      this.state.field_tree_id,
      _param
    )
      .then(() => {
        EventMg.trigger(FIELD_TREE_PARTNER_BOX.SEARCH_CLEAR);
      })
      .catch(() => ({ result: false }));

    if (data.result) {
      this.setState({ data: { ...this.state.copy_data } });
    }
  };

  /**
   * @description 絞り込み初期化処理
   */
  searchFormInit = () => {
    EventMg.addEventListener(FIELD_TREE_PARTNER_BOX.DROPDOWN_VALUE, arg => {
      this.dropdownCallback(arg);
      this.setState({ showDragItem: false, isLoading: false, isFetch: false });
    });

    EventMg.addEventListener(
      FIELD_TREE_PARTNER_BOX.SERACH_PARAM_UPDATE,
      (name, value) => {
        this.radioButtonCallback(name, value);
        this.setState({
          showDragItem: false,
          isLoading: false,
          isFetch: false,
        });
      }
    );
  };

  /**
   * ドロップダウンのコールバック
   * @param {dom} element
   * @param {string} name
   * @param {*} value
   */
  dropdownCallback = arg => {
    //element, name, value
    const name = arg[1];
    const value = arg[2];

    if (!name && !value) {
      return;
    }
    let params = _.clone(this.state.tempParams);
    if (name === 'fields') {
      params['name'] = value;
    }
    if (name === 'fullname') {
      params['name'] = value.fullname;
    } else {
      params[name] = value;
    }

    if (params) {
      this.setState({
        data: [],
        paramReset: this.state.paramReset + 1,
        tempParams: params,
      });
    }
  };

  /**
   * @description 絞り込みラジオボタン
   * @param {string} name
   * @param {object} value
   */
  radioButtonCallback = (name, value) => {
    if (_.isString(name) && _.isNumber(value)) {
      const params = _.clone(this.state.tempParams);
      params[name] = value;
      this.setState({ data: [], paramReset: this.state.paramReset + 1 });
      this.setState({ tempParams: params });
    }
  };

  /**
   * @description table itemのデータを追加ロードする
   * @param {Array|Any} list_data 取得したデータ一覧
   */
  fieldItemLoad = async list_data => {
    const params = _.clone(this.state.params);
    if (_.isArray(list_data)) {
      params.offset = list_data.length;
    }
    if (!params.partner_company_branch_id) {
      delete params.partner_company_branch_id;
    } else if (params.partner_company_branch_id === HEAD_OFFICE_OPTION.id) {
      params.partner_company_branch_id = null;
    }

    const data = await fetchMg
      .GetAjax(
        `/api/private/fields/${this.state.field_id}/field_trees/${
          this.state.field_tree_id
        }/field_tree_users/list`,
        params
      )
      .catch(error => {
        let message;
        if (error && error.length) {
          message = _.get(error[0], 'responseJSON.message');
        }
        return { result: false, message };
      });
    ///api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users/list

    if (data.result) {
      this.total = data.data.total; // 検索結果件数を取得

      let _data = [...this.state.data];
      _data.push(...data.data.entities.field_tree_users);
      this.setState({
        data: _data,
        isLoading: false,
        isFetch: false,
        isNewSearch: false,
      });

      let sortedData = _.sortBy(data.data.entities.field_tree_users, user => {
        return user.order_number;
      });
      sortedData = _.sortBy(sortedData, user => {
        return user.block_flag;
      });
      if (_.has(data, 'data.entities.empty_partner_box_flag')) {
        this.setState({
          isShowWarningAddUser: !!_.get(
            data,
            'data.entities.empty_partner_box_flag'
          ),
        });
      }

      if (this.searchButtonRef.current) {
        this.searchButtonRef.current.disabled = false;
      }

      return sortedData;
    }
    let { showInformationModal, informationMessage } = _.cloneDeep(this.state);
    if (data.message) {
      showInformationModal = true;
      informationMessage = data.message;
    }
    this.setState({
      showInformationModal,
      informationMessage,
      data: [],
      isLoading: false,
      isFetch: false,
    });

    return [];
  };

  /**
   * モーダルの表示(このメソッドはHeaderItemNewまでバケツリレーで渡す)
   *
   * @memberof FieldTreePartnerBox
   */
  showModal = () => {
    // 共通協力会社に職長登録時、同協力会社内にログイン済みの番頭が居なければエラーにする。
    this.setState({
      showModal: true,
      updateSuccess: true,
      updateMsg: messageUtility.getMessage('E-001-102'),
    });
  };

  /**
   * @description 検索実行
   */
  searchExecution = () => {
    this.searchButtonRef.current.disabled = true;

    this.setState({
      params: _.cloneDeep(this.state.tempParams),
      isFetch: true,
      isLoading: true,
      isNewSearch: true,
    });
  };

  getSearchForm = (isOpen, total, fieldTreeId, fieldId, canDrag) => {
    const showSearchPartnerCompanyBranch = !!this.state.company.company_id;
    return (
      <div
        className='master-slide-view__searchform'
        style={{ borderBottom: 'none' }}
      >
        {!canDrag && (
          <div className='search-form'>
            <SearchFormHeader isOpen={isOpen} total={total} />
            <div
              id='search-form-accordion'
              className={isOpen ? 'accordion show' : 'accordion'}
            >
              <div className='search-form__body'>
                <div className='form form--search-form'>
                  <div className='form__group flex-wrap'>
                    {showSearchPartnerCompanyBranch && (
                      <SearchFormElement
                        label='支店'
                        eleClass='form-element__element'
                      >
                        <PartnerCompanyBranchDropdown
                          selectedCompanyId={this.state.company.company_id}
                          selectedPartnerCompanyBranchId={
                            this.state.partnerCompanyBranchIdSearched
                          }
                          onSelect={partnerCompanyBranchIdSearched => {
                            this.setState({ partnerCompanyBranchIdSearched });
                            EventMg.trigger(
                              FIELD_TREE_PARTNER_BOX.DROPDOWN_VALUE,
                              [
                                undefined,
                                'partner_company_branch_id',
                                partnerCompanyBranchIdSearched,
                              ]
                            );
                          }}
                          isOptional={true}
                          fixedOptions={[HEAD_OFFICE_OPTION]}
                          params={{ call_from: CALL_FROM_PAGE.FIELD_TREE_PAGE }}
                          dropdownSelectStyle={{ width: '165px' }}
                          clearFlag={this.clearFlag}
                        />
                      </SearchFormElement>
                    )}
                    <SearchFormElement
                      label='ユーザー種別'
                      eleClass='form-element__element'
                    >
                      <SearchFormRadio
                        label='管理者'
                        name='role_code'
                        checked={
                          this.state.tempParams['role_code'] ===
                          USER_ROLES.partner.id
                        }
                        value={USER_ROLES.partner.id}
                      />
                      <SearchFormRadio
                        label={USER_ROLES.foreman.name}
                        name='role_code'
                        checked={
                          this.state.tempParams['role_code'] ==
                          USER_ROLES.foreman.id
                        }
                        value={USER_ROLES.foreman.id}
                      />
                      {/* <SearchFormRadio
                        label={USER_ROLES.operator.name}
                        name='role_code'
                        value={7}
                      /> */}
                    </SearchFormElement>
                    <SearchFormElement
                      label='協力会社ユーザー名'
                      eleClass='form-element__element'
                    >
                      <UsersDropdownSelector
                        className='jobs_item'
                        label='ユーザーを選択'
                        multiple={false}
                        api={params =>
                          FieldTreeService.getUsersOfPartner(
                            fieldId,
                            fieldTreeId,
                            params
                          )
                        }
                        apiParams={{}}
                        apiSearchKey='name'
                        selectedValues={
                          this.state.user_id
                            ? [String(this.state.user_id)]
                            : undefined
                        }
                        selectedName={this.state.name}
                        keyName='fullname'
                        valueName='user_id'
                        apiBindDataKey={'field_tree_users'}
                        onSelect={(user_id, user_name) => {
                          this.setState({
                            user_id,
                            user_name,
                          });
                          EventMg.trigger(
                            FIELD_TREE_PARTNER_BOX.DROPDOWN_VALUE,
                            [undefined, 'name', user_name]
                          );
                        }}
                        isOptional={true}
                        clearFlag={this.clearFlag}
                      />
                    </SearchFormElement>
                    <SearchFormElement
                      label='ステータス'
                      eleClass='form-element__element'
                    >
                      <SearchFormRadio
                        label={USER_BOX_STATUS.active.text}
                        name='is_blocked'
                        checked={
                          this.state.tempParams['is_blocked'] ===
                          USER_BOX_STATUS.active.value
                        }
                        value={USER_BOX_STATUS.active.value}
                      />
                      <SearchFormRadio
                        label={USER_BOX_STATUS.deactivate.text}
                        name='is_blocked'
                        checked={
                          this.state.tempParams['is_blocked'] ===
                          USER_BOX_STATUS.deactivate.value
                        }
                        value={USER_BOX_STATUS.deactivate.value}
                      />
                      <SearchFormRadio
                        label={USER_BOX_STATUS.blocked.text}
                        name='is_blocked'
                        checked={
                          this.state.tempParams['is_blocked'] ===
                          USER_BOX_STATUS.blocked.value
                        }
                        value={USER_BOX_STATUS.blocked.value}
                      />
                    </SearchFormElement>
                    <SearchFormElement eleClass='form-element__element'>
                      <button
                        className='btn-fixedsize--stay search-form__btn__pertnerBox'
                        onClick={this.searchExecution}
                        ref={this.searchButtonRef}
                      >
                        検索
                      </button>
                    </SearchFormElement>
                  </div>
                  {showSearchPartnerCompanyBranch && (
                    <div className='search-form__info'>
                      <div className='search-form__info-text'>
                        検索条件で支店を選択してユーザーが見つからない場合、支店を未選択にし氏名のみで再度検索してください。
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <Modal modalRoot='root' modalState={this.state.showModal}>
          <DialogSuccessError
            msg={this.state.updateMsg}
            updateSuccess={this.state.updateSuccess}
            success={() => this.setState({ showModal: false })}
            error={() => this.setState({ showModal: false })}
          />
        </Modal>
      </div>
    );
  };

  checkDialogNeed = () => {
    if (this.state.canSort) {
      this.handleVisibleDialog(DIALOG_NAME.close);
    } else {
      EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
      masterSlideLoader.show(
        'FieldTreePage',
        { state: { id: 1 } },
        this.props.vw
      );
    }
  };

  /**
   * @description ダイアログ開閉設定
   * @param {string} visibleDialogName ダイアログ名(DIALOG_NAME)
   *                                   ※ nullの場合は、ダイアログを閉じる
   * @param {string} apiMessage APIレスポンスメッセージ
   */
  handleVisibleDialog = (visibleDialogName, apiMessage = null) => {
    this.setState({ visibleDialogName, apiMessage });
  };

  closeConfirmationDialog = () => {
    this.setState(
      {
        showSendConfirmDialog: false,
      },
      () => {
        dialogLoader.close();
        EventMg.trigger(FIELD_TREE_PARTNER_BOX.INVITE_USER_DIALOG);
      }
    );
  };

  handleChangeFieldTreeSuccess = fieldTree => {
    this.setState(prevState => ({
      company: {
        ...prevState.company,
        representative: fieldTree.representative,
        work_hour_zone_day_flag: fieldTree.work_hour_zone_day_flag,
        work_hour_zone_night_flag: fieldTree.work_hour_zone_night_flag,
        work_hour_zone_midnight_flag: fieldTree.work_hour_zone_midnight_flag,
      },
      partner_company_branch_id: fieldTree.partner_company_branch_id,
      partnerCompanyBranchName: fieldTree.partner_company_branch_name,
      partnerCompanyBranchBlockFlag:
        fieldTree.partner_company_branch_block_flag,
    }));
  };

  render() {
    const {
      visibleDialogName,
      apiMessage,
      isLoading,
      isFetch,
      isNewSearch,
    } = this.state;

    return (
      <div
        ref={event => {
          this.slideRef = event;
        }}
        className='master-slide-view show PartnerBox'
      >
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 施工体系図</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={
              //「本社名」+「支店名」（ある場合）+「の確認・編集」
              _.some([
                this.state.company.company_name,
                this.state.company.company_branch_name,
              ]) &&
              `${this.state.company.company_name}` +
                `${
                  this.state.company.company_branch_name
                    ? ` ${this.state.company.company_branch_name}の確認・編集`
                    : 'の確認・編集'
                }`
            }
            onClose={this.checkDialogNeed}
          />
          <div id='infinityscroll-target' className='master-slide-view__table'>
            <HeaderMenu
              vw={this.props.vw}
              canDrag={this.state.canSort}
              company={this.state.company}
              field_tree_id={this.state.field_tree_id}
              approval_flags={this.state.approval_flags}
              showModal={this.showModal}
              showDragItem={this.state.showDragItem}
              permissions={this.state.permissions}
              role_id={this.state.role_id}
              isShowWarningAddUser={this.state.isShowWarningAddUser}
            />
            {this.getSearchForm(
              this.state.search_form_open,
              this.total,
              this.state.field_tree_id,
              this.state.field_id,
              this.state.canSort
            )}
            <HeaderSubMenu
              show={isPrimaryCompanyRoleId(this.state.role_id)}
              vw={this.props.vw}
              id={this.state.field_tree_id}
              field_data={this.state.field_data}
              fieldId={this.state.field_id}
              company={this.state.company}
              work_history_exists={this.state.work_history_exists}
              onVisibleDialog={this.handleVisibleDialog}
              displayWorkHourZone={this.state.displayWorkHourZone}
              onChangeFieldTreeSuccess={this.handleChangeFieldTreeSuccess}
            />
            <div className='fieldstree-main__header'>
              <div className='fieldstree-main__menu fieldstree-main__menu--no-padding'>
                <div
                  className='master-slide-view__body'
                  style={{ width: '100%' }}
                >
                  <div className='constructionlist__list'>
                    <EditTable
                      canSort={this.state.canSort}
                      paramReset={this.state.paramReset}
                      parentId='infinityscroll-target'
                      onLoad={this.fieldItemLoad.bind(this)}
                      header={() => <TableHeader />}
                      body={props => (
                        <PartnerTableItem
                          vw={this.props.vw}
                          canDrag={this.state.canSort}
                          editable={
                            this.state.permissions.user &&
                            this.state.permissions.user.edit
                          }
                          fieldTreeId={this.state.field_tree_id}
                          {...props}
                          refresh={() =>
                            EventMg.trigger(FIELD_TREE_PARTNER_BOX.REFRESH_LIST)
                          }
                          userId={this.userId}
                        />
                      )}
                      params={this.state.params}
                      edituserid={this.state.edit_user_id}
                      master={this.state.master}
                      isLoading={isLoading}
                      isFetch={isFetch}
                      isNewSearch={isNewSearch}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Confirmation
          visible={visibleDialogName === DIALOG_NAME.close}
          title={messageUtility.getMessage('I-000-closeEditWindow')}
          message={messageUtility.getMessage('I-000-confirmCloseEditWindow')}
          confirmButtonText={messageUtility.getMessage('I-000-closeEditWindow')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          isVerticalButton={true}
          onConfirm={() => {
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.SAVE_ORDER, false);
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.SEARCH_CLEAR);
            this.handleVisibleDialog(null);
          }}
          onCancel={() => this.handleVisibleDialog(null)}
        />
        <Information
          visible={this.state.showInformationModal}
          title={messageUtility.getMessage('E-001-402')}
          message={this.state.informationMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.setState({ showInformationModal: false })}
          multilineText={true}
        />
        <Information
          visible={this.state.showRequestRegisterDialog}
          title={messageUtility.getMessage('I-000-183')}
          message={messageUtility.getMessage('I-000-182')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.setState({ showRequestRegisterDialog: false })}
          multilineText={true}
        />
      </div>
    );
  }
}

/**
 *
 */
class EditTable extends Table {
  constructor(props) {
    super(props);
  }

  //ここで並び替え後のリストを取得してコールバックする
  sortList = (dragIndex, to_index) => {
    super.sortList(dragIndex, to_index);
    EventMg.trigger(FIELD_TREE_PARTNER_BOX.ORDER_UPDATE, this.state.list_data);
  };

  /**
   * @description ボディーを返す。
   */
  setBody = () => {
    if (this.props.body) {
      return _.map(this.state.list_data, (data, i) => {
        const key = `${this.id}-${i}`;

        return this.props.body({
          data,
          key,
          index: i,
          id: this.id,
          canDrag: this.props.canSort,
          onBeginDrag: () => ({ index: i }),
          onDropped: result => this.sortList(result, i),
        });
      });
    }

    return null;
  };
}

/**
 * @description リスト一覧のヘッダー部分
 */
const TableHeader = () => (
  <thead className='table__header'>
    <tr className='table__label'>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label' />
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>支店</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>ユーザー種別</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>氏名</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>ID</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>職種</div>
      </td>
      {/* <td className='value-table value-table--table__label'>
        <div className='value-table__label'>元請担当</div>
      </td> */}
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>サービス権限</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label'>ステータス</div>
      </td>
      <td className='value-table value-table--table__label'>
        <div className='value-table__label' />
      </td>
    </tr>
  </thead>
);

/**
 * Tooltipで表示される文字
 * @param {string} data 表示データ
 */
const renderTooltipContent = data => {
  const rowStyle = {
    maxWidth: '240px',
    wordWrap: 'break-word',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>{data}</div>
    </React.Fragment>
  );
};

/**
 * @description Table Item コンポーネント
 *
 */
class PartnerTableItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canDrag: true,
    };
  }

  onEndDrag = (drop_result, props, monitor, component) => {
    this.setState({ canDrag: false });
    if (this.props.onEndDrag) {
      return this.props.onEndDrag(drop_result, props, monitor, component);
    }
  };

  onDropped = (dropProps, monitor, dropComponent) => {
    if (this.props.onDropped) {
      return this.props.onDropped(dropProps, monitor, dropComponent);
    }
  };

  onBeginDrag = (props, monitor, component) => {
    if (this.props.onBeginDrag) {
      return this.props.onBeginDrag(props, monitor, component);
    }
  };

  /**
   * @description ドラッグ＆ドロップできるようにラップする
   * @param {React.ReactElement} elements
   */
  setWrapperDnd = elements => {
    if (this.props.canDrag) {
      return (
        <DragSourceAndDropTarget
          id={this.props.id}
          onDropped={this.onDropped}
          onBeginDrag={this.onBeginDrag}
          onEndDrag={this.onEndDrag}
          canDrag={this.props.canDrag}
        >
          {elements}
        </DragSourceAndDropTarget>
      );
    }

    return elements;
  };

  getNowYMD = () => {
    const dt = new Date();
    const y = dt.getFullYear();
    const m = `00${dt.getMonth() + 1}`.slice(-2);
    const d = `00${dt.getDate()}`.slice(-2);
    const result = `${y}/${m}/${d}`;
    return result;
  };

  showErrorDialog = message => {
    return new Promise(resolve => {
      dialogLoader.show(dialog.submitErrorMessage, {
        message,
        callback: {
          done: () => {
            resolve(true);
            dialogLoader.close();
          },
        },
      });
    });
  };

  /**
   * @description オプションのicon一覧を返す。
   * @param {Object} data
   */
  setOptionIcons = data => {
    let dialogOption = {};
    const { canDrag } = this.props;
    const clickable = canDrag ? '' : 'clickable';
    if (data.block_flag === 1) {
      return (
        <div className='status--mid--blocked'>
          {USER_BOX_STATUS.blocked.text}
        </div>
      );
    }

    if (!data.blocked_on) {
      dialogOption.iconClassName = `status--mid--caution ${clickable}`;
      dialogOption.blockedOn = this.getNowYMD();
      dialogOption.displayName = USER_BOX_STATUS.active.text;
      dialogOption.value = USER_BOX_STATUS.active.value;
    } else {
      dialogOption.iconClassName = `status--mid ${clickable}`;
      dialogOption.blockedOn = null;
      dialogOption.displayName = USER_BOX_STATUS.deactivate.text;
      dialogOption.value = USER_BOX_STATUS.deactivate.value;
    }

    return (
      <div
        className={dialogOption.iconClassName}
        onClick={() => {
          if (canDrag) {
            return;
          }

          dialogLoader.show(dialog.ConfirmEditStatus, {
            value: dialogOption.value,
            callback: {
              back: () => {
                dialogLoader.close();
              },
              save: () => {
                if (data.block_flag === USER_STATUS.stop.id) {
                  dialogLoader.show(dialog.ErrorMessageNoTitle, {
                    message:
                      'このユーザーは、ユーザー自体が使用停止になっているため、ステータスを変えることはできません。使用を再開する場合はユーザー一覧画面で状態を変更する必要があります。',
                    callback: {
                      done: () => {
                        dialogLoader.close();
                      },
                    },
                  });
                } else {
                  // BLDE_V2-37705 自身の作業終了時には確認ダイアログを表示
                  if (this.props.userId == data.user_id) {
                    this.changeMyStatus(data, dialogOption);
                  } else {
                    this.updateFieldTreeUserStatus(
                      data.field_id,
                      data.field_tree_id,
                      data.id,
                      dialogOption.blockedOn
                    );
                    dialogLoader.close();
                  }
                }
              },
            },
          });
        }}
      >
        {dialogOption.displayName}
      </div>
    );
  };

  /**
   * @description 自身を作業終了にする場合の処理
   * @param {Object} data
   */
  changeMyStatus = (data, dialogOption) => {
    if (dialogOption.blockedOn) {
      dialogLoader.show(dialog.ChangeMyStatusDialog, {
        callback: {
          onCancel: () => {
            dialogLoader.close();
          },
          onConfirm: () => {
            FieldTreeService.update(
              data.field_id,
              data.field_tree_id,
              data.id,
              { blocked_on: dialogOption.blockedOn }
            )
              .then(() => {
                SessionStorageService.removeInformationRelatedToField();
                window.location.replace('/conference/Fields:1/0/0/0/0');
                this.props.refresh();
              })
              .catch(() => {
                this.showErrorDialog(
                  '更新に失敗しました。画面を更新後に再度実行してください。'
                );
              });
            dialogLoader.close();
          },
        },
      });
    } else {
      this.updateFieldTreeUserStatus(
        data.field_id,
        data.field_tree_id,
        data.id,
        dialogOption.blockedOn
      );
      dialogLoader.close();
    }
  };

  updateFieldTreeUserStatus = (field_id, field_tree_id, id, blocked_on) => {
    FieldTreeService.update(field_id, field_tree_id, id, { blocked_on })
      .then(() => {
        this.props.refresh();
      })
      .catch(() => {
        this.showErrorDialog(
          '更新に失敗しました。画面を更新後に再度実行してください。'
        );
      });
  };

  setOptionLevel = data => {
    if (data.approval_flag == 0) {
      return 'レベル1';
    } else if (data.approval_flag == 1) {
      return 'レベル2';
    } else if (data.approval_flag == 2) {
      return 'レベル3';
    } else if (data.approval_flag == 3) {
      return 'レベル4';
    }
  };

  /**
   * ユーザー種別
   */
  setUserType = data => {
    let userRoleName = '';
    //本社管理者=2,支店管理者=3,現場監督=4
    if (data.role_code == USER_ROLES.partner.id) {
      userRoleName = '管理者';
    } else if (data.role_code == USER_ROLES.foreman.id) {
      userRoleName = USER_ROLES.foreman.name;
    } else if (data.role_code == USER_ROLES.operator.id) {
      userRoleName = USER_ROLES.operator.name;
    }

    let showBuildeeManagerIcon = false;
    if (
      _.has(data, 'permissions.buildee_manager_flg') &&
      data.permissions.buildee_manager_flg
    ) {
      showBuildeeManagerIcon = true;
    }

    return (
      <div className={`value-table__txt--5 value-table__user-type`}>
        {showBuildeeManagerIcon && (
          <BuildeeManagerIcon className={`icon--2x`} />
        )}
        {userRoleName}
      </div>
    );
  };

  /**
   * @description サービスのアイコン設定
   * @param {object} permissions サービス権限
   */
  renderServiceIcons = permissions => {
    let icons = [];
    if (permissions) {
      // 調整会議
      if (permissions.use_chosei_flg) {
        icons.push(<div className='option-icon-chosei' />);
      } else {
        icons.push(<div className='option-icon-empty' />);
      }
      // 入退場
      if (permissions.use_nyutaijo_flg) {
        icons.push(<div className='option-icon-entrance' />);
      } else {
        icons.push(<div className='option-icon-empty' />);
      }
      // 労務安全
      if (permissions.use_green_file_flg) {
        icons.push(<div className='option-icon-greenfile' />);
      } else {
        icons.push(<div className='option-icon-empty' />);
      }
    }
    return _.map(icons, (icon, i) => (
      <span
        key={`value-table__content-no.${i}`}
        className='value-table__content PartnerBox__service-icon'
      >
        {icon}
      </span>
    ));
  };

  render() {
    const { data } = this.props;

    const dragable = () => {
      return this.props.canDrag
        ? { display: 'table-cell' }
        : { display: 'none' };
    };
    const disabled = () => {
      if (!this.props.editable) {
        return { display: 'none' };
      }
      return !this.props.canDrag
        ? { display: 'table-cell' }
        : { display: 'none' };
    };

    // const constructor_user_name = user => {
    //   return user
    //     ? `${user.manager_user_name_sei} ${user.manager_user_name_mei}`
    //     : '';
    // };

    const jobs = () => {
      if (!data.field_tree_user_jobs.length) {
        return;
      }
      let jobs = [];
      jobs = data.field_tree_user_jobs.map(job => job.job_name);
      return _.join(jobs, ', ');
    };
    const partnerCompanyBranchName =
      _.get(data, 'partner_company_branch.name') || '本社';

    return this.setWrapperDnd(
      <tr className='table__item'>
        <td className='value-table value-table--btn-drag'>
          <div className='value-table__icon'>
            <button
              style={dragable()}
              className='btn-icon--sm'
              onMouseDown={() => this.setState({ canDrag: true })}
            >
              <i className='i-drag i-3x' />
            </button>
          </div>
        </td>
        <td className='value-table construction-list-value-table__branch-name'>
          <span className='label'>支店</span>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            role={`tippy_target_${_.uniqueId()}`}
            html={renderTooltipContent(partnerCompanyBranchName)}
          >
            <div className='value-table__txt--7'>
              {partnerCompanyBranchName}
            </div>
          </Tippy>
        </td>
        <td className='value-table construction-list-value-table__branch-name'>
          <span className='label'>ユーザー種別</span>
          {this.setUserType(data)}
        </td>
        <td className='value-table construction-list-value-table__name'>
          <span className='label'>氏名</span>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            role={`tippy_target_${_.uniqueId()}`}
            html={renderTooltipContent(
              _.defaultTo(`${data.user_name_sei} ${data.user_name_mei}`, '')
            )}
          >
            <div className='value-table__txt--10'>
              {_.defaultTo(`${data.user_name_sei} ${data.user_name_mei}`, '')}
            </div>
          </Tippy>
        </td>
        <td className='value-table construction-list-value-table__name'>
          <span className='label'>ID</span>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            role={`tippy_target_${data.login_id}`}
            html={renderTooltipContent(_.defaultTo(data.login_id, ''))}
          >
            <div className='value-table__txt--10'>
              {_.defaultTo(data.login_id, '')}
            </div>
          </Tippy>
        </td>
        <td className='value-table construction-list-value-table__address'>
          <span className='label'>職種</span>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={renderTooltipContent(jobs(data.field_tree_user_jobs))}
          >
            <div className='value-table__txt--10'>
              {jobs(data.field_tree_user_jobs)}
            </div>
          </Tippy>
        </td>
        <td className='value-table construction-list-value-table__address'>
          <span className='label'>サービス権限</span>
          <div className='value-table__txt--9' style={{ minWidth: '116px' }}>
            {this.renderServiceIcons(data.permissions)}
          </div>
        </td>
        <td className='value-table construction-list-value-table__option'>
          <span className='label'>ステータス</span>
          <div className='value-table__normal'>{this.setOptionIcons(data)}</div>
        </td>
        <td className='value-table construction-list-value-table__edit'>
          <div className='value-table__button-3'>
            {this.props.data.block_flag === 0 && this.props.editable && (
              <button
                style={disabled()}
                className='btn--sm--stay'
                onClick={() => {
                  EventMg.trigger(FIELD_TREE_PARTNER_BOX.EDIT_FORM, data);
                }}
              >
                編集
              </button>
            )}
          </div>
        </td>
      </tr>
    );
  }
}

/**
 * 通常ヘッダー
 * 1次請けでかつ1次請けユーザの場合に承認申請ができる
 */
class HeaderMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editmode: false,
    };
  }

  renderDescription = () => {
    const { isShowWarningAddUser, company } = this.props;
    const approvalFlag = _.toNumber(company.approval_flag);
    let isUnApproval = false;
    if (
      approvalFlag === APPROVAL_STATUS_FIELDTREE.invited.id ||
      approvalFlag === APPROVAL_STATUS_FIELDTREE.pending.id
    ) {
      isUnApproval = true;
    }
    if (isShowWarningAddUser || isUnApproval) {
      return (
        <Description type='primary'>
          {isShowWarningAddUser && (
            <Fragment>
              現場にアクセスできるユーザーがいないため、協力会社ユーザーの追加を行ってください。
              <br />
              現場に追加されていないユーザーや作業終了のユーザーは、現場内の操作を行うことができません。
              <br />
              <br />
              <div className='Description__content--title'>
                協力会社ユーザーの役割
              </div>
              <ul className='Description__content--list'>
                <li className='Description__content--list-item'>
                  協力会社管理者：自社および作業員情報の登録、自社ユーザーの招待や下位協力会社の追加、各サービス内での操作を行います。
                </li>
                <li className='Description__content--list-item'>
                  職長：調整会議の各種予定登録に必要です。稼働中の職長がいない場合、各種予定登録ができません。
                </li>
              </ul>
            </Fragment>
          )}
          {isUnApproval && (
            <div>
              {isShowWarningAddUser && <br />}
              ユーザーへの招待メールは、こちらの施工体制が元請に承認されたタイミングで送信されます。
            </div>
          )}
        </Description>
      );
    }
  };

  render() {
    return (
      <div className='master-slide-view__menu master-slide-view__menu--partner-box'>
        {this.props.permissions.partner_box_detail &&
          !this.state.editmode &&
          !this.props.canDrag &&
          !this.props.company.finish_flag == 1 && (
            <React.Fragment>
              <ul className='btn-menu'>
                {this.props.permissions.partner_box_detail.search_and_add && (
                  <HeaderItemSearchAndAdd />
                )}
                {// 元請けのみ表示（並び順変更、作業終了、職長初期PW再発行(?)、CSV出力）
                isLoginUserPrimaryCompany() && (
                  <React.Fragment>
                    <li className='btn-menu__item sm--hidden '>
                      <div className='segment-line' />
                    </li>
                    <HeaderItemOrder
                      show={
                        isPrimaryCompanyRoleId(
                          LocalStorageService.getRoleId()
                        ) && this.props.showDragItem
                      }
                    />
                  </React.Fragment>
                )}
                {isLoginUserPrimaryCompany() && (
                  <li className='btn-menu__csv-item'>
                    <HeaderItemCSVExport
                      fieldId={this.props.company.field_id}
                      fieldTreeId={this.props.field_tree_id}
                    />
                  </li>
                )}
              </ul>
              {this.renderDescription()}
            </React.Fragment>
          )}
        {this.props.canDrag && (
          <ul className='btn-menu'>
            <li className='btn-menu__item'>
              <button
                className='btn'
                onClick={() => {
                  EventMg.trigger(FIELD_TREE_PARTNER_BOX.SAVE_ORDER, true);
                }}
              >
                保存
              </button>
            </li>
            <li className='btn-menu__item --fx-auto' />
          </ul>
        )}
        {isApiFlagOn(this.props.company.finish_flag) && (
          <Description>
            現場での作業が終了しています。協力会社ユーザーは現場にアクセスできません。
            <br />
            協力会社ユーザーによる現場内の操作が必要な場合は、作業終了の取消を行ってください。
          </Description>
        )}
      </div>
    );
  }
}

/***
 * ヘッダーアイテム 検索して追加
 */
const HeaderItemSearchAndAdd = () => (
  <li className='btn-menu__item'>
    <button
      className='btn'
      onClick={() => {
        EventMg.trigger(FIELD_TREE_PARTNER_BOX.SEARCH_AND_ADD);
      }}
    >
      ユーザーを現場に招待
    </button>
  </li>
);

/***
 * ヘッダーアイテム 並び順を変更する
 */
const HeaderItemOrder = props => (
  <TouchDeviceInvisible>
    <li
      className='btn-menu__item'
      style={{ display: props.show ? 'block' : 'none' }}
    >
      <button
        className='btn--sub'
        onClick={() => {
          EventMg.trigger(FIELD_TREE_PARTNER_BOX.DRAG_ITEM);
        }}
      >
        並び順を変更する
      </button>
    </li>
  </TouchDeviceInvisible>
);

/***
 * ヘッダーアイテム CSV出力
 */
const HeaderItemCSVExport = ({ fieldId, fieldTreeId }) => {
  /**
   * "職長の初期パスワードを再発行"のダイアログを表示
   *
   */
  const showDialog = () => {
    dialogLoader.show(ForemanNewPasswordDialog, {
      // ForemanNewPasswordDialog側でthis.props.dialog.paramsで取得できる
      params: {
        fieldId,
        fieldTreeId,
        // 協力会社BOX詳細タイプ
        dialogType: DialogType.PARTNER_BOX_DETAIL,
      },
      callback: {
        back: () => {
          dialogLoader.close();
        },
        submit: () => {
          dialogLoader.close();
        },
      },
    });
  };

  return (
    <ul className='btn-menu__csv-export-list'>
      <li className='btn-menu__item'>
        <button
          className='btn--sub'
          onClick={() => {
            EventMg.trigger(FIELD_TREE_PARTNER_BOX.EXPORT_CSV);
          }}
        >
          表示データをCSV出力
        </button>
      </li>
      <li className='btn-menu__item'>
        <PrimeContractorButton
          buttonClass='btn--sub'
          // TODO: iPadサイズにしたときに詰まってしまったり変な見た目になるようであれば、「パスワード」の部分を「PW」にしておいてください。
          label={messageUtility.getMessage('I-001-004')}
          onClick={showDialog}
        />
      </li>
    </ul>
  );
};

/* eslint react/no-string-refs: "off" */
class HeaderSubMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mastergroups: [],
      //field_data: props.field_data,
    };
    this.lastchecked = null;
    this.isSubmittingFlag = false;
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps, this.props)) {
      /* eslint react/no-find-dom-node: "off" */
      const component = ReactDOM.findDOMNode(this.myRef);
      if (component) {
        const worktimecheck = (displayWorkHourZone, company, key) => {
          if (displayWorkHourZone[key] == 1) {
            return company[key] == 1 ? true : false;
          }
          return false;
        };

        component.querySelector('input[name="representative"]').value =
          this.props.company.representative || '';
        const _displayWorkHourZone = this.props.displayWorkHourZone;
        const _company = this.props.company;
        component.querySelector(
          'input[name="work_hour_zone_day_flag"]'
        ).checked = worktimecheck(
          _displayWorkHourZone,
          _company,
          'work_hour_zone_day_flag'
        );
        component.querySelector(
          'input[name="work_hour_zone_night_flag"]'
        ).checked = worktimecheck(
          _displayWorkHourZone,
          _company,
          'work_hour_zone_night_flag'
        );
        component.querySelector(
          'input[name="work_hour_zone_midnight_flag"]'
        ).checked = worktimecheck(
          _displayWorkHourZone,
          _company,
          'work_hour_zone_midnight_flag'
        );
      }
    }
  }

  // 更新
  submit = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const _param = {
      id: this.props.id,
      field_id: this.props.fieldId,
      partner_company_branch_id: this.props.company.partner_company_branch_id,
    };
    if (this.props.company.permissions.partner_box_detail.field_agent) {
      if (this.refs.representative.value.length > 64) {
        await this.showErrorDialog(
          '現場代理人は64文字以下で入力してください。'
        );
        this.isSubmittingFlag = false;
        return;
      }
      _param.representative = this.refs.representative.value;
    }
    if (this.props.company.permissions.partner_box_detail.edit_time_zone) {
      let counter = 0;
      _.each(workZonelabels, v => {
        _param[v.ref] = this.refs[v.ref].checked ? '1' : '0';
        counter += this.refs[v.ref].checked ? 1 : 0;
      });
      if (counter === 0) {
        await this.showErrorDialog(
          '作業時間帯は１つ以上の時間帯を使用するようにしてください。'
        );
        this.isSubmittingFlag = false;
        return;
      }
    }

    const data = await fetchMg
      .PatchAjax(
        `/api/private/fields/${this.props.fieldId}/field_trees/${
          this.props.id
        }`,
        _param
      )
      .catch(error => ({
        result: false,
        message: error[0].responseJSON.message,
      }));
    if (data.result) {
      this.props.onChangeFieldTreeSuccess(data.data.entities.field_tree);
      dialogLoader.show(ConfirmDialog, {
        message: messageUtility.getMessage('I-000-049'),
        callback: {
          confirm: () => {
            dialogLoader.close();
          },
        },
      });
    } else if (data.message) {
      await this.showUpdateErrorDialog(data.message);
    }
    this.isSubmittingFlag = false;
  };

  showUpdateErrorDialog = async message => {
    return new Promise(resolve => {
      dialogLoader.show(dialog.submitErrorMessage, {
        title: messageUtility.getMessage('E-000-005'),
        message,
        callback: {
          done: () => {
            resolve(true);
            dialogLoader.close();
          },
        },
      });
    });
  };

  showErrorDialog = async message => {
    return new Promise(resolve => {
      dialogLoader.show(dialog.submitErrorMessage, {
        message,
        callback: {
          done: () => {
            resolve(true);
            dialogLoader.close();
          },
        },
      });
    });
  };

  checkboxClick = () => {
    let checks = _.filter(workZonelabels, v => {
      return this.refs[v.ref].checked === true;
    });
    if (checks.length === 1) {
      this.lastchecked = checks[0];
    }
  };

  handlePartnerCompanyBranchDropdownChange = id => {
    this.props.company.partner_company_branch_id =
      id === HEAD_OFFICE_OPTION.id ? null : Number(id);
    this.props.company.partner_company_branch_name = null;
    this.forceUpdate();
  };

  setRef = node => {
    this.myRef = node;
  };

  render() {
    const formShow = () => {
      return this.props.company.permissions
        ? { display: 'flex' }
        : { display: 'none' };
    };

    const representativeStyle = () => {
      return this.props.company.permissions &&
        this.props.company.permissions.partner_box_detail.field_agent
        ? { display: 'flex' }
        : { display: 'none' };
    };

    const workHoursShow = () => {
      return this.props.company.permissions &&
        this.props.company.permissions.partner_box_detail.edit_time_zone
        ? { display: 'flex' }
        : { display: 'none' };
    };

    const workHourZoneStyle = time => {
      return isApiFlagOn(time) ? { display: 'flex' } : { display: 'none' };
    };

    const checkboxOperatable = () => {
      const { permissions } = this.props.company;
      if (permissions && !permissions.partner_box_detail.edit_time_zone) {
        return 'disabled';
      }
      return null;
    };

    return (
      <div className='fieldstree-option'>
        <div className='fieldstree-option__notice'>
          サービス権限の変更は、所属会社の企業管理者のみが行えます。
          <br />
          企業管理者はユーザー種別欄に
          <BuildeeManagerIcon
            className={`icon--2x`}
            style={{ verticalAlign: 'top' }}
          />
          が表示されます。
        </div>
        <div
          ref={this.setRef}
          className='fieldstree-main__option'
          style={formShow()}
        >
          {!!this.props.company.company_id && (
            <div className='fieldstree-option__item'>
              <div className='fieldstree-option__label'>
                <span className='label'>支店</span>
              </div>
              <div className='fieldstree-option__element'>
                <PartnerCompanyBranchDropdown
                  selectedCompanyId={this.props.company.company_id}
                  selectedPartnerCompanyBranchId={
                    this.props.company.partner_company_branch_id ||
                    HEAD_OFFICE_OPTION.id
                  }
                  previewValue={
                    this.props.company.partner_company_branch_name ||
                    HEAD_OFFICE_OPTION.name
                  }
                  onSelect={this.handlePartnerCompanyBranchDropdownChange}
                  fixedOptions={[HEAD_OFFICE_OPTION]}
                  params={{ call_from: CALL_FROM_PAGE.FIELD_TREE_PAGE }}
                  isOptional={false}
                  dropdownSelectStyle={{ width: '180px' }}
                />
              </div>
            </div>
          )}
          <div
            className='fieldstree-option__item'
            style={representativeStyle()}
          >
            <div className='fieldstree-option__label'>
              <span className='label'>現場代理人</span>
            </div>
            <div className='fieldstree-option__element'>
              <input
                disabled={
                  this.props.company.permissions &&
                  !this.props.company.permissions.partner_box_detail.field_agent
                }
                className='fieldstree-option__input'
                ref='representative'
                type='text'
                name='representative'
              />
            </div>
          </div>
          <div className='fieldstree-option__item' style={workHoursShow()}>
            <div className='fieldstree-option__label'>
              <span className='label'>作業時間帯</span>
            </div>
            <div
              className='fieldstree-option__element fieldstree-option__element--work-hour-zone'
              onClick={() => {
                this.checkboxClick();
              }}
            >
              <label
                className={'checkbox'}
                style={workHourZoneStyle(
                  this.props.displayWorkHourZone.work_hour_zone_day_flag
                )}
              >
                <input
                  type='checkbox'
                  ref='work_hour_zone_day_flag'
                  name='work_hour_zone_day_flag'
                  disabled={checkboxOperatable()}
                />
                <i className='i-square i-3x' />
                昼間
              </label>
              <label
                className='checkbox'
                style={workHourZoneStyle(
                  this.props.displayWorkHourZone.work_hour_zone_night_flag
                )}
              >
                <input
                  type='checkbox'
                  ref='work_hour_zone_night_flag'
                  name='work_hour_zone_night_flag'
                  disabled={checkboxOperatable()}
                />
                <i className='i-square i-3x' />
                夜間
              </label>
              <label
                className='checkbox'
                style={workHourZoneStyle(
                  this.props.displayWorkHourZone.work_hour_zone_midnight_flag
                )}
              >
                <input
                  type='checkbox'
                  ref='work_hour_zone_midnight_flag'
                  name='work_hour_zone_midnight_flag'
                  disabled={checkboxOperatable()}
                />
                <i className='i-square i-3x' />
                深夜
              </label>
            </div>
          </div>
          <div className='fieldstree-option__item'>
            <button
              className='btn--sm--stay fieldstree-option__submit'
              onClick={() => {
                this.submit();
              }}
            >
              保存
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const SearchFormHeader = ({ isOpen, total }) => (
  <div className='search-form__header'>
    <div className='search-form__title'>
      検索条件（検索結果
      <span className='bold'>{total}</span>
      件)
    </div>
    <button
      id='accordion-toggle'
      className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
      onClick={() => EventMg.trigger(FIELD_TREE_PARTNER_BOX.SEARCH_FORM_OPEN)}
    />
    <button
      className='btn-text--sm'
      onClick={() => EventMg.trigger(FIELD_TREE_PARTNER_BOX.SEARCH_CLEAR)}
    >
      検索条件クリア
    </button>
  </div>
);

const SearchFormRadio = ({ label, name, value, checked }) => (
  <div className='element__item'>
    <label className='radio'>
      <input
        name={`radio-${name}`}
        type='radio'
        checked={checked}
        onChange={() =>
          EventMg.trigger(
            FIELD_TREE_PARTNER_BOX.SERACH_PARAM_UPDATE,
            name,
            value
          )
        }
      />
      <i className='i-2x' />
      <span>{label}</span>
    </label>
  </div>
);

const SearchFormElement = ({ label, children, eleClass }) => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>{label}</span>
    </div>
    <div className={eleClass}>{children}</div>
  </div>
);

/**
 * 協力会社ユーザー名
 */
class UsersDropdownSelector extends DropdownSelector {
  setValue = () => {
    const { ...state } = this.state;
    state.selected = state.temporarySelected;
    state.selectAll = state.temporarySelectAll;
    state.selectedName = state.temporarySelectedName;
    state.opened = this.state.multiple;

    this.setState(state, () => {
      // プルダウンの呼び出しコンポーネントでの処理
      this.props.onSelect(state.selected, state.selectedName);
    });
  };
}



// WEBPACK FOOTER //
// ./src/pages/FieldTreePartnerBox.jsx